import React, { useCallback } from 'react'

import { twMerge } from 'tailwind-merge'

import { TagComboboxMulti } from '@/components/tags/TagCombobox'

import type { UUID } from '@/types/Id'

interface TagSelectProps {
  value: UUID[]
  onChange: (value: UUID[]) => void
  triggerClassName?: string
}

export const TagSelect: React.FC<TagSelectProps> = ({
  value,
  onChange,
  triggerClassName,
}) => {
  const handleChange = useCallback(
    (value: string[]) => {
      onChange(value.map((v) => v as UUID))
    },
    [onChange],
  )

  return (
    <TagComboboxMulti
      value={value}
      onChange={handleChange}
      triggerClassName={twMerge('h-6 text-[13px]', triggerClassName)}
    />
  )
}
